<template>
  <bm-overlay
    ref="customOverlay"
    :class="{ sample: true, active }"
    pane="labelPane"
    @draw="draw"
  >
    <div class="name" v-text="text" @click="handleClick"></div>
    <div class="mianji">
      剩余面积：{{ text2 }}{{ danWei == "万平方米" ? "万m²" : "亩" }}
    </div>
  </bm-overlay>
</template>

<script>
export default {
  props: ["text", "text2", "position", "active", "danWei"],
  watch: {
    position: {
      handler() {
        this.$refs.customOverlay.reload();
      },
      deep: true,
    },
  },
  methods: {
    handleClick() {
      //   global.alert('Well done.')
    },
    draw({ el, BMap, map }) {
      const { lng, lat } = this.position;
      const pixel = map.pointToOverlayPixel(new BMap.Point(lng, lat));
      el.style.left = pixel.x - 78 + "px";
      el.style.top = pixel.y - 90 + "px";
    },
  },
};
</script>


<style scoped>
.sample {
  width: 160px;
  height: 50px;
  line-height: 40px;
  background: #ffffff;
  color: #333333;
  text-align: center;
  position: absolute;
  border-radius: 10px;
}
.sample::before {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  font-size: 0;
  transform: rotate(45deg);
  border-width: 8px;
  border-style: solid dashed dashed;
  border-color: transparent #fff #fff transparent;
  box-shadow: 1px 1px 1px #ccc;
  bottom: -8px;
  left: 68.7px;
}
.name {
  position: absolute;
  width: 100%;
  top: -7px;
  text-align: center;
}
.mianji {
  position: absolute;
  width: 100%;
  line-height: 16px;
  top: 24px;
}
/* .name {
  position: absolute;
  width: 100%;
  top: -7px;
  text-align: center;
} 
.mianji {
  text-align: center;
  position: absolute;
  top: 12px;
  width: 100%;
} */
</style>
